<div class="activation-success-container">
  <div class="content-wrapper">
    <img class="logo-img" src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />

    <div class="success-title">Successful</div>

    <img class="success-img" src="/assets/images/successful-sign-up.png" alt="Success" />

    <div class="activation-message">
      Please check your email for <br />
      the activation link.
    </div>

    <div class="spam-message">
      <span>If you don’t see it in your inbox, check the spam folder and mark it as </span>
      <span class="highlight">Not Spam!</span>
    </div>

    <button mat-raised-button color="primary" class="ok-button" (click)="onSignUpSuccess()">OK</button>
  </div>

  <div class="footer">
    <span>Powered by</span>
    <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
  </div>
</div>